// Оферта и политика обработки данных: страницы, а не файлы. SMY-215
//
// ⚠️ ТЕКСТ ЧИТАЕТСЯ ИЗ `docs/legal/published/`, А НЕ ЛЕЖИТ ЗДЕСЬ КОПИЕЙ.
//
// Это единственное место, где документ и опубликованный документ обязаны
// совпадать буквально: расхождение здесь означает, что человек принял не то,
// что написано у нас. Копия в вёрстке разошлась бы с источником на первой же
// правке — и разошлась бы молча, потому что сверять две простыни глазами
// никто не станет.
//
// Каталог `published` отделён от `docs/legal/` намеренно: в самих документах
// живёт наш разбор — «не читан юристом», «что осталось решить», — и он в
// опубликованный текст попасть не должен ни при каких условиях.
//
// Разметка отрисовывается тем же `Answer`, что и ответы модели: заголовки,
// абзацы, списки, выделения. Таблиц он не понимает, поэтому в опубликованных
// текстах их нет — единственная таблица политики переписана списком.

import { useParams } from 'react-router'

import aupText from '../../../../docs/legal/published/aup.md?raw'
import offerText from '../../../../docs/legal/published/offer.md?raw'
import privacyText from '../../../../docs/legal/published/privacy.md?raw'
import unitsText from '../../../../docs/legal/published/units.md?raw'
import { Answer } from '../ui/index.ts'

/** Какие документы опубликованы. Адрес — часть договора, менять нельзя. */
const DOCS: Record<string, { title: string; text: string }> = {
  offer: { title: 'Оферта', text: offerText },
  privacy: { title: 'Политика обработки данных', text: privacyText },
  aup: { title: 'Правила использования', text: aupText },
  units: { title: 'Правила списания единиц', text: unitsText },
}

export function Legal() {
  const { doc } = useParams<{ doc: string }>()
  const found = doc != null ? DOCS[doc] : undefined

  if (found == null) {
    return (
      <main className="legal">
        <h1 className="legal__title">Такого документа нет</h1>
        <p className="legal__note">
          Проверьте адрес. Опубликованы <a href="/legal/offer">оферта</a>,{' '}
          <a href="/legal/privacy">политика обработки данных</a>,{' '}
          <a href="/legal/aup">правила использования</a> и{' '}
          <a href="/legal/units">правила списания единиц</a>.
        </p>
      </main>
    )
  }

  return (
    <main className="legal">
      <Answer>{found.text}</Answer>
    </main>
  )
}
